import { Controller } from "@hotwired/stimulus"

// TerritorioEditor di pages/Grants.js: le «pillole» di regioni, province e comuni (ognuna con il suo campo nascosto,
// disattivato quando non è scelta), le province della regione scelta più quelle già scelte, i comuni aggiunti dal
// ComunePicker. Cambiando ambito: Italia o UE → «Nessun requisito di sede»; da «nessuna» a un ambito locale → «operativa».
// Le sezioni per ambito si mostrano con mostra_se_controller.
const CHIP_ON = "bg-zinc-900 text-white border-zinc-900"
const CHIP_OFF = "bg-white text-zinc-600 border-zinc-300 hover:border-zinc-400"

export default class extends Controller {
  static targets = ["ambito", "sede", "provRegione", "comuni", "comune"]

  scambia(event) {
    const b = event.currentTarget
    const campo = this.element.querySelector(`input[data-elenco="${b.dataset.elenco}"][data-valore="${CSS.escape(b.dataset.valore)}"]`)
    const on = campo.disabled
    campo.disabled = !on
    this.colora(b, on)
    if (b.dataset.elenco === "province") this.filtraProvince()
  }

  colora(b, on) {
    b.classList.remove(...(on ? CHIP_OFF : CHIP_ON).split(" "))
    b.classList.add(...(on ? CHIP_ON : CHIP_OFF).split(" "))
  }

  filtraProvince() {
    const regione = this.provRegioneTarget.querySelector("[data-select-target='input']").value
    this.element.querySelectorAll("button[data-elenco='province']").forEach((b) => {
      const scelta = !this.element.querySelector(`input[data-elenco="province"][data-valore="${CSS.escape(b.dataset.valore)}"]`).disabled
      b.hidden = !(b.dataset.regione === regione || scelta)
    })
  }

  ambito(event) {
    if (event.target !== this.ambitoTarget) return
    const v = event.detail.value
    const sede = this.sedeTarget.querySelector("[data-select-target='input']")
    const nuova = ["ue", "italia"].includes(v) ? "nessuna" : (sede.value === "nessuna" ? "operativa" : sede.value)
    if (nuova === sede.value) return
    sede.value = nuova
    this.application.getControllerForElementAndIdentifier(this.sedeTarget, "select")?.sync()
  }

  aggiungiComune(event) {
    const c = event.detail.comune
    if (!c || this.comuniTarget.querySelector(`[data-comune="${CSS.escape(c.code)}"]`)) return
    const voce = this.comuneTarget.content.firstElementChild.cloneNode(true)
    voce.dataset.comune = c.code
    voce.querySelector("button").textContent = `${c.comune} ×`
    voce.querySelector("input").value = c.code
    this.comuniTarget.append(voce)
  }

  togliComune(event) {
    event.currentTarget.closest("[data-comune]").remove()
  }
}
